<style>

.inquiries .name {
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: .15rem;
    line-height: 2.5rem;
}

.inquiries.bg-black {
    min-height: 85vh;
}

</style>

<template>

<div class="bg-black inquiries md:w-container mx-auto mt-16">
    <div class="flex h-full flex-col">
        <div class="flex flex-col justify-center flex-1">


            <div class="flex flex-wrap text-center">

                <div class="w-full  md:w-1/2">


                    <div class="p-5 md:p-10"">
                        <span class="name">Peter Turchin</span>
                        <br />
                        <a href="mailto:&#112;&#101;&#116;&#101;&#114;&#046;&#116;&#117;&#114;&#099;&#104;&#105;&#110;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;">&#112;&#101;&#116;&#101;&#114;&#046;&#116;&#117;&#114;&#099;&#104;&#105;&#110;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;</a>
                        <br/>212.984.8364


                    </div>
                    <div class="p-5 md:p-10"">
                        <span class="name">Christie Harle</span>
                        <br />
                        <a href="mailto:&#099;&#104;&#114;&#105;&#115;&#116;&#105;&#101;&#046;&#104;&#097;&#114;&#108;&#101;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;">&#099;&#104;&#114;&#105;&#115;&#116;&#105;&#101;&#046;&#104;&#097;&#114;&#108;&#101;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;</a>
                        <br/>212.984.8389
                    </div>
                </div>

                <div class="w-full  md:w-1/2">

                    <div class="p-5 md:p-10"">
                        <span class="name">Caroline Merck</span>
                        <br />
                        <a href="mailto:&#099;&#097;&#114;&#111;&#108;&#105;&#110;&#101;&#046;&#109;&#101;&#114;&#099;&#107;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;">&#099;&#097;&#114;&#111;&#108;&#105;&#110;&#101;&#046;&#109;&#101;&#114;&#099;&#107;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;</a>
                        <br/>212.984.8336
                    </div>

                    <div class="p-5 md:p-10"">

                        <span class="name">  Brad Auerbach</span>
                        <br />
                        <a href="mailto:&#098;&#114;&#097;&#100;&#108;&#101;&#121;&#046;&#097;&#117;&#101;&#114;&#098;&#097;&#099;&#104;&#064;&#099;&#098;&#114;&#101;&#046;&#099;&#111;&#109;">bradley.auerbach@cbre.com</a>
                        <br/>212.984.7139
                    </div>


                </div>





            </div>







        </div>
    </div>
</div>

</template>

<script>

export default {
    name: 'inquiries',
}

</script>
